export default __webpack_public_path__ + "static/media/checkmark.5c70b2df.svg";